import { createAction, props } from '@ngrx/store';
import { Microcourse } from 'src/app/models/microcourse.model';

export const open = createAction(
  '[Drawer] Open',
  props<{ course: Microcourse }>()
);

export const close = createAction('[Drawer] Close');
